<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-2">
        <h5>電話帳</h5>
      </div>
      <div class="col-6 text-right">
        <button v-show="isAdmin && isUseFunction"                           type="button" class="btn-sm btn-outline-info" v-on:click="create">連絡先を登録する</button>
        <button v-show="isAdmin && !isExtra"                                type="button" class="btn-sm btn-outline-success" v-on:click="openModal">最新のユーザーを反映する</button>
        <button v-show="isAdmin && isUseFunction"                           type="button" class="btn-sm btn-outline-primary" v-on:click="importCsv">CSVをimportする</button>
        <b-dropdown v-if="isAdmin" v-show="extraContactId != 0" text="CSVをexportする" size="sm" variant="outline-success" class="rounded" style="border:1px #0F0 groove" >
          <b-dropdown-item v-on:click="exportCsv('sjis')">Shift_JIS</b-dropdown-item>
          <b-dropdown-item v-on:click="exportCsv('utf8')">UTF-8</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-11 align-center" v-show="isUseFunction">
        <label>電話帳を選択してください</label>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-3">
        <div class="form-group">
          <select class="form-control" v-model="extraContactId" v-on:change="selectContact(true)">
            <option v-for="option in contactOptions" v-bind:value="option.id" v-bind:key="option.id">
              {{ option.contactName }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-5" style="margin-top: 2px;">
        <button v-show="isAdmin && !isExtra && !isMaximum && isUseFunction" type="button" class="btn-sm btn-outline-info" v-on:click="extraCreate">電話帳を追加する</button>
        <button v-show="isAdmin && isExtra  && isUseFunction" type="button" class="btn-sm btn-outline-info" v-on:click="extraModify">電話帳を編集する</button>
      </div>
    </div>
    <div id="seach_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8 form-group">
        <form class="input-group" @submit.prevent="search(true)">
          <input type="text" class="form-control" v-model="searchKey" placeholder="名称、かな">
          <div class="input-group-append">
              <button class="btn btn-secondary" type="submit">
                <img class="search-solid" src="/search-solid.svg">
              </button>
          </div>
        </form>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th                               scope="col" style="width:70px">#</th>
              <th                               scope="col">名称</th>
              <th                               scope="col">ふりがな</th>
              <th v-show="extraContactId === 0" scope="col">所属</th>
              <th                               scope="col" style="min-width:60px">番号</th>
              <th v-if="isAdmin"                scope="col" style="width:100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contact, index) in contacts" v-bind:key="contact.contactId">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ contact.contactName }}</td>
              <td>{{ contact.contactKana }}</td>
              <td v-show="extraContactId === 0" >{{ setDisplayName(contact) }}</td>
              <td>{{ contact.extensionNumber }}</td>
              <td>
                <button v-if="isAdmin" type="button" class="btn-sm btn-light" v-on:click="modify(contact.contactId)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-4">
      </div>
    </div>
    <RefreshCommonContactModal v-show="showContent" v-on:close-modal="closeModal" v-bind:realms="realms" @latest-id-applied="reloadListData"/>
  </div>
</template>

<script>
import axios from 'axios'
import Encoding from 'encoding-japanese'
import authority from '../../authority'
import RefreshCommonContactModal from './../../components/RefreshCommonContactModal'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'
import { saveAs } from 'file-saver';

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  src: {
    authority
  },
  components: {
    RefreshCommonContactModal
  },
  data: function(){
    return {
      contacts: [],
      extraContactId: 0,
      contactOptions: [
        {
          id: 0,
          contactName: "共通連絡先"
        }
      ],
      message: '',
      searchKey: '',
      showContent: false,
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
      csvData: '',
    }
  },
  mounted() {
    if(this.$store.getters.contactSearch.searchKey !== ''){
      this.searchKey = this.$store.getters.contactSearch.searchKey
    }
    if(this.$store.getters.contactSearch.currentIndex !== 0){
      this.currentIndex = this.$store.getters.contactSearch.currentIndex
    }
    if(this.$store.getters.hospital.id !== 0){
      this.getContactList()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.extraContactId = 0
          this.contactOptions = [
            {
              id: 0,
              contactName: "共通連絡先"
            }
          ]
          this.getContactList()
          this.selectContact(true)
        }
      }
    )
    if(this.$store.getters.contact.extraContactId == 0) {
      this.selectContact(false)
    }
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isAdmin: function () {
      var overAdmin = authority.isAdmin.concat(authority.isSuper)
      return overAdmin.includes(Number(this.$store.state.user.privilege))
    },
    isExtra: function () {
      return this.extraContactId > 0
    },
    isMaximum: function () {
      return this.contactOptions.length === 4
    },
    isUseFunction: function() {
      return this.serviceName === 'Nichibyo'
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/create/'+this.extraContactId))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/modify/'+this.extraContactId+'/'+id))
    },
    extraCreate() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/extracreate'))
    },
    extraModify() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/extramodify/'+this.extraContactId))
    },
    importCsv() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/import'))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .post("/api/contact/management/public/list/" + offset, {
              hospitalId : hospitalId,
              searchKey: this.searchKey,
              extraContactId: this.extraContactId
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.contacts = response.data.data.contacts
              this.gridCount = this.contacts.length
              this.$store.commit('contactSearch',{
                searchKey: this.searchKey,
                currentIndex: this.currentIndex
              })
            })
            .catch(err => {
              this.message = err.message
              this.$store.commit('contactSearch',{
                searchKey: '',
                currentIndex: 0
              })
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getContactList() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .get("/api/extracontact/management/list/" + hospitalId, {
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.contactOptions = this.contactOptions.concat(response.data.data.extraContacts)
              this.extraContactId = this.$store.getters.contact.extraContactId
              this.search(false)
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    selectContact(isInit) {
      var extraContactId = this.extraContactId
      if (extraContactId === 0){
        this.$store.commit('contact',{
          extraContactId: this.extraContactId, isHierarchyGroupEnabled: this.$store.getters.hospital.isHierarchyGroupEnabled
          })
        this.search(isInit)
      } else {
        this.$cognito.isAuthenticated().then((session) => {
          if(session){
            var accessToken = this.getAccessToken(this.$cognito,session)
              axios
                .get("/api/extracontact/management/" + extraContactId, {
                    headers: this.headers(accessToken)
                })
                .then(response => {
                  this.$store.commit('contact',{
                    extraContactId: this.extraContactId, isHierarchyGroupEnabled: response.data.data.extraContact.isHierarchyGroupEnabled
                    })
                  this.search(isInit)
                })
                .catch(err => {
                  this.message = err.message
                })
          } else {
            this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
          }
        }).catch((err) => {
            this.message = err.message
        })
      }
    },
    setDisplayName(contact) {
      if (contact.user === null) return "";
      if (contact.user.organization === null) return "";
      if (contact.user.organization.displayName === null) return "";
      return contact.user.organization.displayName;
    },
    exportCsv(type){
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var hospitalId = this.$store.getters.hospital.id;
          var extraContactId = this.extraContactId;
          var accessToken = this.getAccessToken(this.$cognito,session);
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                        ? "/api/contact/extra/csv/hierarchyGroup"
                        : "/api/contact/extra/csv/group"
            axios.post(url, {
              hospitalId: hospitalId,
              extraContactId: extraContactId
            },{
              headers: this.headers(accessToken)
            }).then((res) => {
              if(res.data.errorMessage) {
                this.message = res.data.errorMessage;
              } else {
                if (type === "utf8"){
                    const fileName = 'contacts_utf8.csv'
                    let blob = new Blob([res.data],{ type: "text/csv;charset=utf-8" });
                    saveAs(blob, fileName); 
                } else if (type === "sjis"){

                // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = new Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);
                    const fileName = 'contacts_sjis.csv'
                    let blob = new Blob([shiftJisString], {type: "text/csv;charset=shift_jis"});
                    saveAs(blob, fileName);
                }
              }
            })
      }}).catch((err) => {
        this.message = err.message
      })
    },
    reloadListData() {
      this.contacts = [];
      this.extraContactId = 0
      this.contactOptions = [
        {
          id: 0,
          contactName: "連絡先"
        }
      ]
      this.currentIndex = 0;
      this.gridCount = 0;
      this.getContactList();
    },
    fetchExcludedUsers() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          //共通連絡先に存在し、かつ「共通連絡先の対象から外す」設定されているユーザーの取得
          axios.get("/api/contact/management/excludedUser/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(response => {
            this.excludedUsers = response.data.excludedUsers
            const excludedUserData = this.excludedUsers
            this.$store.commit('excludedUserData', excludedUserData)
          }).catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    openModal(){
      this.fetchExcludedUsers()
      this.showContent = true
    },
    closeModal(){
      this.showContent = false
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
button {
  margin-right: 10px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
  z-index: 1;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>